<template>
  <div class="hardware">
    <div class="header">
      <div class="title">物联网智能硬件</div>
      <div class="border"></div>
    </div>
    <div class="title-list">
      <div
        class="item"
        v-for="item in hardwareTitleList"
        :key="item.id"
        @mouseenter="titleTab(item.id)"
      >
        <img :src="item.logo" alt="" />
        <div :class="titleId == item.id ? 'active' : ''">{{ item.title }}</div>
      </div>
    </div>
    <div class="hardware-list">
      <div class="list">
        <div class="item" v-for="item in hardwareList" :key="item.id">
          <div class="box" v-if="titleId == item.id">
            <div class="left">
              <div
                class="left-item"
                v-for="it in item.leftList"
                :key="it.id"
                :style="`background-image: url(${it.logo});`"
              >
                <div class="title">{{ it.title }}</div>
              </div>
            </div>
            <div class="right">
              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.text }}</div>
              <div class="right-list">
                <div
                  class="right-item"
                  v-for="it in item.rightList"
                  :key="it.id"
                >
                  <img class="logo" :src="it.logo" alt="" />
                  <div class="item-title">{{ it.title }}</div>
                </div>
              </div>
              <router-link :to="item.path">
                <button class="more">了解更多</button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import hardwareRouter1 from "../../../assets/programme/hardwareRouter1.png";
import hardwareRouter2 from "../../../assets/programme/hardwareRouter2.png";
import hardwareRouter3 from "../../../assets/programme/hardwareRouter3.png";
import hardwareRouter4 from "../../../assets/programme/hardwareRouter4.png";
import hardwareRouter5 from "../../../assets/programme/hardwareRouter5.png";
import hardwareRouter6 from "../../../assets/programme/hardwareRouter6.png";
import hardwareRouter7 from "../../../assets/programme/hardwareRouter7.png";
import hardwareRouter8 from "../../../assets/programme/hardwareRouter8.png";

import doorLogo1 from "../../../assets/programme/doorLogo1.png";
import doorLogo2 from "../../../assets/programme/doorLogo2.png";
import doorLogo3 from "../../../assets/programme/doorLogo3.png";
import doorLogo4 from "../../../assets/programme/doorLogo4.png";
import doorLogo5 from "../../../assets/programme/doorLogo5.png";
import doorLogo6 from "../../../assets/programme/doorLogo6.png";
import doorLogo7 from "../../../assets/programme/doorLogo7.png";
import doorLogo8 from "../../../assets/programme/doorLogo8.png";
import doorLogo9 from "../../../assets/programme/doorLogo9.png";
import doorLogo10 from "../../../assets/programme/doorLogo10.png";
import doorLogo11 from "../../../assets/programme/doorLogo11.png";
import doorLogo12 from "../../../assets/programme/doorLogo12.png";
import doorLogo13 from "../../../assets/programme/doorLogo13.png";
import doorLogo14 from "../../../assets/programme/doorLogo14.png";
import doorLogo15 from "../../../assets/programme/doorLogo15.png";
import doorLogo16 from "../../../assets/programme/doorLogo16.png";
import doorLogo17 from "../../../assets/programme/doorLogo17.png";
import doorLogo18 from "../../../assets/programme/doorLogo18.png";
import doorLogo19 from "../../../assets/programme/doorLogo19.png";
import doorLogo20 from "../../../assets/programme/doorLogo20.png";
import doorLogo21 from "../../../assets/programme/doorLogo21.png";
import doorLogo22 from "../../../assets/programme/doorLogo22.png";
import doorLogo23 from "../../../assets/programme/doorLogo23.png";
import doorLogo24 from "../../../assets/programme/doorLogo24.png";
import doorLogo25 from "../../../assets/programme/doorLogo25.png";
import doorLogo26 from "../../../assets/programme/doorLogo26.png";
import doorLogo27 from "../../../assets/programme/doorLogo27.png";
import doorLogo28 from "../../../assets/programme/doorLogo28.png";
import doorLogo29 from "../../../assets/programme/doorLogo29.png";
import doorLogo30 from "../../../assets/programme/doorLogo30.png";
import doorLogo31 from "../../../assets/programme/doorLogo31.png";
import doorLogo32 from "../../../assets/programme/doorLogo32.png";
import doorLogo33 from "../../../assets/programme/doorLogo33.png";
import doorLogo34 from "../../../assets/programme/doorLogo34.png";
import doorLogo35 from "../../../assets/programme/doorLogo35.png";
import doorLogo36 from "../../../assets/programme/doorLogo36.png";
import doorLogo37 from "../../../assets/programme/doorLogo37.png";
import doorLogo38 from "../../../assets/programme/doorLogo38.png";
import doorLogo39 from "../../../assets/programme/doorLogo39.png";
import doorLogo40 from "../../../assets/programme/doorLogo40.png";

import yesLogo from "../../../assets/programme/yesLogo.png";

export default {
  setup() {
    return reactive({
      titleId: 1,
      hardwareTitleList: [
        {
          id: 1,
          title: "智能门禁",
          logo: hardwareRouter1,
        },
        {
          id: 2,
          title: "智能监控",
          logo: hardwareRouter2,
        },
        {
          id: 3,
          title: "楼宇对讲",
          logo: hardwareRouter3,
        },
        {
          id: 4,
          title: "智能梯控",
          logo: hardwareRouter4,
        },
        {
          id: 5,
          title: "智能家居",
          logo: hardwareRouter5,
        },
        {
          id: 6,
          title: "智能充电",
          logo: hardwareRouter6,
        },
        {
          id: 7,
          title: "智能停车",
          logo: hardwareRouter7,
        },
        {
          id: 8,
          title: "智能能耗",
          logo: hardwareRouter8,
        },
      ],
      hardwareList: [
        {
          id: 1,
          title: "智能门禁",
          text: "多种通行方式自由选择，提高出行效率",
          path: '/pc/programme/accesscontrol',
          rightList: [
            {
              id: 1,
              title: "一键开门",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "访客邀约",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "防夹控制",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "人脸识别",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "海量储存",
              logo: yesLogo,
            },
            {
              id: 6,
              title: "安全高效",
              logo: yesLogo,
            },
          ],
          leftList: [
            {
              id: 1,
              title: "指纹识别开门",
              logo: doorLogo1,
            },
            {
              id: 2,
              title: "商务楼人脸识别门禁",
              logo: doorLogo2,
            },
            {
              id: 3,
              title: "手机一键开门",
              logo: doorLogo3,
            },
            {
              id: 4,
              title: "传统纽扣卡",
              logo: doorLogo4,
            },
            {
              id: 5,
              title: "二维码开门",
              logo: doorLogo5,
            },
            {
              id: 6,
              title: "小区人行门禁",
              logo: doorLogo6,
            },
          ],
        },
        {
          id: 2,
          title: "智能监控",
          text: "云监控 实时监控报警 全方位保驾护航",
          path: '/pc/programme/monitor',
          rightList: [
            {
              id: 1,
              title: "360°无死角",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "视频回放",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "远程监控",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "防御报警",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "安全保障",
              logo: yesLogo,
            },
          ],
          leftList: [
            {
              id: 1,
              title: "远程监控",
              logo: doorLogo7,
            },
            {
              id: 2,
              title: "人形人脸声源识别",
              logo: doorLogo8,
            },
            {
              id: 3,
              title: "视频回放",
              logo: doorLogo9,
            },
            {
              id: 4,
              title: "开启防御报警",
              logo: doorLogo10,
            },
          ],
        },
        {
          id: 3,
          title: "楼宇对讲",
          text: "集中管理 远程监控 保障居住安全的“守护神”",
          path: '/pc/programme/intercom',
          rightList: [
            {
              id: 1,
              title: "音质好",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "安全性高",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "稳定性高",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "性能可靠",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "经济有效",
              logo: yesLogo,
            },
          ],
          leftList: [
            {
              id: 1,
              title: "一人值班 集中管理",
              logo: doorLogo11,
            },
            {
              id: 2,
              title: "一键开启可视对讲",
              logo: doorLogo12,
            },
            {
              id: 3,
              title: "访客到访 远程开门",
              logo: doorLogo13,
            },
            {
              id: 4,
              title: "广告投放 开启智慧商圈",
              logo: doorLogo14,
            },
          ],
        },
        {
          id: 4,
          title: "智能梯控",
          text: "多种通行方式自由选择，提高出行效率",
          path: '/pc/programme/laddercontrol',
          rightList: [
            {
              id: 1,
              title: "设定权限",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "便捷性强",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "高校性强",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "使用数据记录",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "扩展功能",
              logo: yesLogo,
            },
          ],
          leftList: [
            {
              id: 1,
              title: "刷卡乘梯",
              logo: doorLogo15,
            },
            {
              id: 2,
              title: "人脸识别乘梯",
              logo: doorLogo16,
            },
            {
              id: 3,
              title: "一键分享访客乘梯",
              logo: doorLogo17,
            },
            {
              id: 4,
              title: "预约乘梯",
              logo: doorLogo18,
            },
            {
              id: 5,
              title: "自动呼梯",
              logo: doorLogo19,
            },
            {
              id: 6,
              title: "欠费停梯",
              logo: doorLogo20,
            },
          ],
        },
        {
          id: 5,
          title: "智能家居",
          text: "通过家庭网关及其系统软件建立智能家居平台系统",
          path: '/pc/programme/homefurnishing',
          rightList: [
            {
              id: 1,
              title: "实用便利",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "标准性",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "方便性",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "轻巧性",
              logo: yesLogo,
            },
          ],
          leftList: [
            {
              id: 1,
              title: "智能门锁",
              logo: doorLogo21,
            },
            {
              id: 2,
              title: "智能家电",
              logo: doorLogo22,
            },
            {
              id: 3,
              title: "智能照明",
              logo: doorLogo23,
            },
            {
              id: 4,
              title: "智能窗控",
              logo: doorLogo24,
            },
            {
              id: 5,
              title: "智能暖通",
              logo: doorLogo25,
            },
            {
              id: 6,
              title: "智能监控",
              logo: doorLogo26,
            },
          ],
        },
        {
          id: 6,
          title: "智能充电",
          text: "高效、智能化的充电体验",
          path: '/pc/programme/charge',
          rightList: [
            {
              id: 1,
              title: "自动断电",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "在线充值",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "过载保护",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "联网定位",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "充电数据分析",
              logo: yesLogo,
            },
            {
              id: 6,
              title: "实时监控",
              logo: yesLogo,
            },
            {
              id: 7,
              title: "语音提示",
              logo: yesLogo,
            },
            {
              id: 8,
              title: "多种计费",
              logo: yesLogo,
            },
          ],
          leftList: [
            {
              id: 1,
              title: "自动断电",
              logo: doorLogo27,
            },
            {
              id: 2,
              title: "语音提示",
              logo: doorLogo28,
            },
            {
              id: 3,
              title: "多种支付方式",
              logo: doorLogo29,
            },
            {
              id: 4,
              title: "实时监控",
              logo: doorLogo30,
            },
            {
              id: 5,
              title: "充电数据分析",
              logo: doorLogo31,
            },
            {
              id: 6,
              title: "远程操控",
              logo: doorLogo32,
            },
          ],
        },
        {
          id: 7,
          title: "智能停车",
          text: "智能找车位+自动缴费停车",
          path: '/pc/programme/parking',
          rightList: [
            {
              id: 1,
              title: "快速通行",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "提供特殊停车位",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "同样空间内停入更多的车辆",
              logo: yesLogo,
            },
          ],
          leftList: [
            {
              id: 1,
              title: "电子支付",
              logo: doorLogo33,
            },
            {
              id: 2,
              title: "车位查询",
              logo: doorLogo34,
            },
            {
              id: 3,
              title: "车位预定",
              logo: doorLogo35,
            },
            {
              id: 4,
              title: "视频识别",
              logo: doorLogo36,
            },
          ],
        },
        {
          id: 8,
          title: "智能能耗",
          text: "远程抄表 余量监控 自动计费 生成订单",
          // path: '/pc/programme/energyconsumption',
          path: '',
          rightList: [
            {
              id: 1,
              title: "数据集中",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "节省能源",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "提前预警 减少故障",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "提高效率",
              logo: yesLogo,
            },
          ],
          leftList: [
            {
              id: 1,
              title: "自动抄表",
              logo: doorLogo37,
            },
            {
              id: 2,
              title: "在线缴费",
              logo: doorLogo38,
            },
            {
              id: 3,
              title: "阀值预警",
              logo: doorLogo39,
            },
            {
              id: 4,
              title: "数据监控",
              logo: doorLogo40,
            },
          ],
        },
      ],
    });
  },
  methods: {
    titleTab(id) {
      this.titleId = id;
    },
  },
};
</script>

<style scoped>
.header {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}
.title-list {
  width: 1180px;
  margin: 40px auto 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-list .item {
  text-align: center;
  cursor: pointer;
}
.title-list .item img {
  width: 68px;
}
.title-list .item div {
  font-size: 13px;
  color: #2a3d50;
}
.title-list .item .active {
  color: #248efb;
  border-bottom: 4px solid #248efb;
  padding-bottom: 6px;
}
@media screen and (max-width: 1180px) {
  .hardware-list {
    min-width: 1180px;
  }
}
.hardware-list {
  background: linear-gradient(180deg, #eff7ff 0%, #fdfeff 100%);
  box-shadow: inset 0px 10px 20px 1px rgba(31, 81, 210, 0.06);
  padding: 60px 0;
}
.hardware-list .list {
  width: 1180px;
  margin: 0 auto;
}
.hardware-list .list .item .box {
  display: flex;
  justify-content: space-between;
}
.hardware-list .list .item .box .left {
  width: 600px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.hardware-list .list .item .box .left .left-item {
  display: flex;
  align-items: flex-end;
  width: 190px;
  height: 147px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-bottom: 15px;
  background-position: center;
}
.hardware-list .list .item .box .left .left-item:hover {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    background-size: 100% 100%;
  }
  100% {
    background-size: 120% 120%;
  }
}
.hardware-list .list .item .box .left .left-item .title {
  width: 100%;
  text-align: center;
  padding: 16px 0;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  backdrop-filter: blur(10px);
}

.hardware-list .list .item .box .right {
  width: 520px;
}

.hardware-list .list .item .box .right .title {
  font-size: 24px;
  color: #2a3d50;
}
.hardware-list .list .item .box .right .text {
  margin-top: 20px;
  font-size: 16px;
  color: #4c6681;
}
.hardware-list .list .item .box .right .right-list {
  display: flex;
  flex-wrap: wrap;
}
.hardware-list .list .item .box .right .right-list .right-item {
  display: flex;
  align-items: center;
  margin-right: 40px;
  margin-top: 32px;
}
.hardware-list .list .item .box .right .right-list .right-item .logo {
  width: 18px;
  margin-right: 10px;
}
.hardware-list .list .item .box .right .right-list .right-item .item-title {
  font-size: 14px;
  color: #2a3d50;
}
.hardware-list .list .item .box .right .more {
  margin-top: 40px;
  width: 124px;
  height: 36px;
  text-align: center;
  border: 1px solid #248efb;
  font-size: 18px;
  color: #248efb;
  border-radius: 6px 6px 6px 6px;
  cursor: pointer;
  background-color: #fff;
}
</style>
